import L, { BaseIconOptions } from 'leaflet'

import { AnyObject, LayerResponse } from '../../constants/types'

import MarkerShadow from 'leaflet/dist/images/marker-shadow.png'

import Auto from '../../icons/markers/auto.svg'
import AutoActive from '../../icons/markers/auto_selected.svg'
import Cultural from '../../icons/markers/cultural.svg'
import CulturalActive from '../../icons/markers/cultural_selected.svg'
import Danger from '../../icons/markers/danger.svg'
import EPAM from '../../icons/markers/epam.svg'
import EPAMActive from '../../icons/markers/epam_selected.svg'
import EPAMers from '../../icons/markers/epamers.svg'
import EPAMersActive from '../../icons/markers/epamers_selected.svg'
import Finance from '../../icons/markers/finance.svg'
import FinanceActive from '../../icons/markers/finance_selected.svg'
import Food from '../../icons/markers/food.svg'
import FoodActive from '../../icons/markers/food_selected.svg'
import Government from '../../icons/markers/government.svg'
import GovernmentActive from '../../icons/markers/government_selected.svg'
import Health from '../../icons/markers/health.svg'
import HealthActive from '../../icons/markers/health_selected.svg'
import KidsEducation from '../../icons/markers/kids_education.svg'
import KidsEducationActive from '../../icons/markers/kids_education_selected.svg'
import Leisure from '../../icons/markers/leisure.svg'
import LeisureActive from '../../icons/markers/leisure_selected.svg'
import Pets from '../../icons/markers/pets.svg'
import PetsActive from '../../icons/markers/pets_selected.svg'
import Realty from '../../icons/markers/realty.svg'
import RealtyActive from '../../icons/markers/realty_selected.svg'
import Sport from '../../icons/markers/sport.svg'
import SportActive from '../../icons/markers/sport_selected.svg'
import Shops from '../../icons/markers/shop.svg'
import ShopsActive from '../../icons/markers/shop_selected.svg'
import Utilities from '../../icons/markers/utilities.svg'
import UtilitiesActive from '../../icons/markers/utilities_selected.svg'

import Default from '../../icons/markers/default.png'
import DefaultActive from '../../icons/markers/default_selected.png'
import MyLocation from '../../icons/markers/my_location.png'

import EventSport from '../../icons/markers/event_sport.svg'
import EventEducation from '../../icons/markers/education_event.svg'
import EventRelax from '../../icons/markers/event_relax.svg'
import EventOther from '../../icons/markers/event_other.svg'
import EventEntertainment from '../../icons/markers/event_entertainment.svg'
import EventCulture from '../../icons/markers/culture_event.svg'
import EventActive from '../../icons/markers/event_active.svg'

const commonIconFields = {
  iconAnchor: [15, 38],
  iconSize: [30, 38],
  popupAnchor: [0, -38],
  shadowUrl: MarkerShadow,
  shadowSize: [41, 41],
  shadowAnchor: [13, 41],
} as BaseIconOptions

const activeIconFields = {
  iconAnchor: [20, 50],
  iconSize: [40, 50],
  shadowSize: [55, 55],
  shadowAnchor: [18, 55],
  popupAnchor: [0, -49],
} as BaseIconOptions

const iconUrls = {
  1: {
    default: Sport,
    active: SportActive,
    name: 'sport',
  },
  4: {
    default: Leisure,
    active: LeisureActive,
    name: 'leisure',
  },
  6: {
    default: EPAMers,
    active: EPAMersActive,
    name: 'epamers',
  },
  10: {
    default: EPAM,
    active: EPAMActive,
    name: 'epam',
  },
  11: {
    default: Realty,
    active: RealtyActive,
    name: 'realty',
  },
  12: {
    default: Health,
    active: HealthActive,
    name: 'health',
  },
  13: {
    default: KidsEducation,
    active: KidsEducationActive,
    name: 'kids_education',
  },
  14: {
    default: Pets,
    active: PetsActive,
    name: 'pets',
  },
  15: {
    default: Government,
    active: GovernmentActive,
    name: 'school',
  },
  16: {
    default: Finance,
    active: FinanceActive,
    name: 'finance',
  },
  17: {
    default: Utilities,
    active: UtilitiesActive,
    name: 'finance',
  },
  18: {
    default: Food,
    active: FoodActive,
    name: 'food',
  },
  19: {
    default: Cultural,
    active: CulturalActive,
    name: 'cultural',
  },
  20: {
    default: Auto,
    active: AutoActive,
    name: 'auto',
  },
  21: {
    default: Danger,
    active: Danger,
    name: 'danger',
  },
  76: {
    default: Shops,
    active: ShopsActive,
    name: 'shops',
  },

  // ----------------------------------------------------------------
  event1: {
    default: EventOther,
    active: EventActive,
  },
  event2: {
    default: EventEntertainment,
    active: EventActive,
  },
  event3: {
    default: EventEducation,
    active: EventActive,
  },
  event4: {
    default: EventSport,
    active: EventActive,
  },
  event5: {
    default: EventRelax,
    active: EventActive,
  },
  event6: {
    default: EventCulture,
    active: EventActive,
  },
  default: {
    default: Default,
    active: DefaultActive,
  },
} as AnyObject

const icons = {} as AnyObject
for (let key in iconUrls) {
  icons[key] = {
    default: new L.Icon({
      ...commonIconFields,
      iconUrl: iconUrls[key].default,
    }),
    active: new L.Icon({
      ...commonIconFields,
      ...activeIconFields,
      iconUrl: iconUrls[key].active,
    }),
    name: iconUrls[key]?.name ?? 'event icon',
  }
}

export const getMarkerIcon = (isActive: boolean, layerId?: number | string) => {
  const iconBylayerId =
    layerId && icons[layerId] ? icons[layerId] : icons.default

  const result = isActive ? iconBylayerId.active : iconBylayerId.default
  return result
}

export const getMyLocationIcon = () => {
  return new L.Icon({
    iconAnchor: [10, 0],
    iconSize: [20, 20],
    iconUrl: MyLocation,
  })
}

export const getMapIconId = (layers: LayerResponse[] = []) => {
  const arr = layers.map(({ parentId, id }) => {
    let mappedId = parentId === null ? +id : +parentId
    // next line is implementing of exception for 'EPAMer' icon
    if (id === 6) mappedId = 6
    return [[`${id}`], mappedId]
  })
  return Object.fromEntries(arr)
}
